var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-container"},[_c('iframe',{staticClass:"blog-iframe",attrs:{"src":"https://fantasylineups.com/blog/","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }